module.exports = __webpack_public_path__ + "a08b8c02b1f8a26698d4eb197008095b.svg";